import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { CompanyAnalysisField, CompanyAnalysisUser } from '../types';
import ResponseCard from './ResponseCard';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';

interface FieldCardProps {
  field: CompanyAnalysisField;
  users: CompanyAnalysisUser[];
}

const FieldCard: React.FC<FieldCardProps> = ({ field, users }) => {
  const theme = useThemeContext();
  const { name, responses, total_responses } = field;

  const topChoiceResponse = responses.reduce((prev, current) =>
    current.percentage > prev.percentage ? current : prev
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: 2,
        backgroundColor: theme.background.secondary,
        p: 1,
        mb: 3,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: 14,
          color: theme.primary,
          fontWeight: 700,
          lineHeight: 1.3,
          mb: 0.5,
        }}
      >
        {name}
      </Typography>

      <Stack spacing={0.5}>
        {responses.map((response, index) => (
          <ResponseCard
            key={`${response.option_id}_${index}`}
            response={response}
            isTopChoice={response.option_id === topChoiceResponse.option_id}
            infoUsers={users}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default FieldCard;
